import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './AssociatedCases.less';

export class AssociatedCasesView extends Component {
  render() {
    const { associatedCases } = this.props;
    const header = 'Associated Cases';

      if (associatedCases.empty) {
        return (<div> </div>);
      }

      const rows = associatedCases.map((item, key) => {
      const ac = item.associated_case || {};
      const cs = item.case || {};
      const leadLink = `/filings/${cs.case_uuid}-`;
      const assocLink = `/filings/${ac.case_uuid}-`;

      return (
        <tr key={key}>
            <td><a href={leadLink}>{ cs.case_code }</a> <span> { cs.case_name || '' } </span></td>
            <td><a href={assocLink}>{ ac.case_code }</a> <span> { ac.case_name || '' } </span></td>
            <td>{ ac.case_type || '' }</td>
            <td>{ cs.date_closed || '' }</td>
        </tr>
      );
      });

      return (
        <div className="associated-cases">
          <h2 className="case-label"></h2>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>Lead Case Title</span></th>
                <th><span>Associated Case Title</span></th>
                <th><span>Type</span></th>
                <th><span>Date Closed</span></th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </table>
        </div>
      );
  }
}

export default AssociatedCasesView;



// WEBPACK FOOTER //
// ./src/components/case/associated_cases/AssociatedCasesView.js